export class PatientLoginSetupCompletionViewModel {
    constructor(container) {
        this.authManager = container.authManager;
        this.patientService = container.patientService;
        this.loginUIManager = container.loginUIManager;
        this.accountSetupCompletionManager = container.accountSetupCompletionManager;
        const patientInfo = this.authManager.consentingPatientInfo;
        this.accountSetupCompletionManager.prepopulate(patientInfo);
    }
    get formModel() {
        return this.accountSetupCompletionManager.formModel;
    }
    get hasAgeValidationError() {
        return this.accountSetupCompletionManager.hasAgeValidationError;
    }
    async continue() {
        if (!this.accountSetupCompletionManager.validateInput())
            return;
        const patientId = this.authManager.id;
        if (!patientId) {
            console.error("No patient ID available for update");
            return;
        }
        const success = await this.patientService.updatePatient(patientId, {
            firstName: this.accountSetupCompletionManager.input.firstName,
            lastName: this.accountSetupCompletionManager.input.lastName,
            dateOfBirth: this.accountSetupCompletionManager.input.birthday,
            phone: this.accountSetupCompletionManager.input.mobilePhone,
        });
        if (success) {
            this.authManager.setAccountSetupCompleted(true);
            await this.authManager.regenerateToken();
            this.loginUIManager.completeSetupAndEndLogin();
        }
        else {
            console.error("Failed to update patient");
        }
    }
}
